import React, { useEffect, useState } from "react";
import AdminTabelHeader from "../../components/layout/header/AdminTabelHeader";
import ManditoryStar from "../../templates/ManditoryStar";
import { useLocation, useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import Swal from "sweetalert2";
import axios from "axios";
import { BASEURL } from "../../../utils/BaseUrl";
import TraingleLoading from "../../../common/Loading/TraingleLoading";

const AdminImageGalleryForm = () => {
  const [imageData, setImageData] = useState({
    title: "",
    images: [],
  });

  const navigate = useNavigate();
  const { state } = useLocation();
  const value = state?.value;

  // useEffect(() => {
  //   if (id) {
  //     setImageData({
  //       ...imageData,
  //       title: state?.value?.title,
  //       images: [{ url: state?.value?.image_url, file: null }],
  //     });
  //   }
  // }, [id]);

  // Handle Multiple Image Selection
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);

    const validImages = files.filter((file) => {
      if (!file.type.startsWith("image/")) {
        alert("Only images are allowed.");
        return false;
      }
      if (file.size > 5 * 1024 * 1024) {
        alert("File size should be less than 5MB.");
        return false;
      }
      return true;
    });

    const newImages = validImages.map((file) => {
      const url = URL.createObjectURL(file);
      return { file, url };
    });

    setImageData((prevData) => ({
      ...prevData,
      images: [...prevData.images, ...newImages],
    }));

    return () => {
      newImages.forEach((img) => URL.revokeObjectURL(img.url));
    };
  };

  const removeImage = (index) => {
    setImageData((prevData) => ({
      ...prevData,
      images: prevData.images.filter((_, i) => i !== index),
    }));
  };

  const mutation = useMutation({
    mutationFn: (values) => axios.post(`${BASEURL}gallery`, values),
    onSuccess: () => {
      Swal.fire({
        title: "ImageGallery Created Successfully",
        icon: "success",
      }).then(() => navigate("/admin/imagegallery"));
    },
    onError: (error) => {
      console.error("Upload Error:", error.response?.data || error.message);
      Swal.fire({
        title: "Upload Failed!",
        text: error.response?.data?.message || "Something went wrong.",
        icon: "error",
      });
    },
  });

  const editMutation = useMutation({
    mutationFn: (values) =>
      axios.put(
        `${BASEURL}gallery?gallery_name=${value?.gallery_name}&new_gallery_name=${values?.toLowerCase()}`
      ),
    onSuccess: () => {
      Swal.fire({
        title: "ImageGallery Updated Successfully",
        icon: "success",
      }).then(() => navigate("/admin/imagegallery"));
    },
    onError: (error) => {
      console.error("Update Error:", error.response?.data || error.message);
      Swal.fire({
        title: "Update Failed!",
        text: error.response?.data?.message || "Something went wrong.",
        icon: "error",
      });
    },
  });

  const handleSubmit = () => {
    const formData = new FormData();
    formData.append("gallery_name", imageData.title?.toLowerCase());
    formData.append("altTag", imageData.title?.toLowerCase());

    imageData.images.forEach((img) => {
      if (img.file) formData.append("images", img.file);
    });

    mutation.mutate(formData);
  };

  const handleUpdate = () => {
    editMutation.mutate(imageData?.title);
  };

  return (
    <div>
      {(mutation.isLoading || editMutation.isLoading) && <TraingleLoading />}
      <AdminTabelHeader
        title={value ? "Edit Image Gallery" : "Add Image Gallery"}
        btnStatus={false}
      />

      <div className="p-4">
        {value && (
          <div>
            <ManditoryStar title={"OldTitle"} />
            <input
              name="title"
              value={value?.gallery_name}
              className="input"
              type="text"
              maxLength={500}
              placeholder="Enter title"
              disabled={true}
            />
          </div>
        )}

        <div>
          <ManditoryStar title={value ? "New Title" : "Title"} />
          <input
            name="title"
            value={imageData.title}
            className="input"
            type="text"
            maxLength={500}
            placeholder="Enter title"
            onChange={(e) =>
              setImageData({ ...imageData, title: e.target.value })
            }
          />
        </div>

        {!value && (
          <div className="grid grid-cols-1 gap-4">
            <div>
              <ManditoryStar title={"Images"} />
              <div className="flex flex-col items-center justify-center p-6 bg-gray-100 rounded-lg shadow-md w-80">
                <label
                  htmlFor="imageInput"
                  className="cursor-pointer flex flex-col items-center justify-center w-full h-20 bg-white border-2 border-dashed border-blue-400 rounded-lg hover:bg-blue-50 transition duration-300"
                >
                  <p className="text-sm text-gray-500 mt-2">
                    Click to upload images
                  </p>
                </label>
                <input
                  type="file"
                  id="imageInput"
                  accept="image/*"
                  multiple
                  className="hidden"
                  onChange={handleImageChange}
                />
              </div>
            </div>
          </div>
        )}

        <div className="grid grid-cols-12 gap-4 mt-4">
          {imageData.images.map((img, index) => (
            <div key={index} className="relative">
              <img
                src={img.url}
                alt="Preview"
                className="w-32 h-32 object-cover rounded-md"
              />
              {!value && (
                <button
                  className="absolute top-1 right-1 bg-red-500 text-white text-xs px-2 py-1 rounded-full"
                  onClick={() => removeImage(index)}
                >
                  ✕
                </button>
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="flex justify-end my-4">
        <button
          onClick={() => navigate(-1)}
          className="formSubmit mr-8 cursor-pointer"
        >
          Cancel
        </button>
        <button
          onClick={value ? () => handleUpdate() : handleSubmit}
          className="formSubmit"
        >
          {value ? "Update" : "Submit"}
        </button>
      </div>
    </div>
  );
};

export default AdminImageGalleryForm;
